module.exports = __webpack_public_path__ + "static/img/NWM.fab1261.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NWM.jpg
// module id = CnH3
// module chunks = 0